import type {
	Components,
} from '@mui/material'

export const materialUILoaderTheme: {
	components: Components
} = {
	components: {
		MuiCircularProgress: {
			styleOverrides: {
				circle: {
					stroke: 'var(--primary-color)',
				},
			},
		},
	},
}
